export default __webpack_public_path__ + "static/media/Karyakarta_Analysis.2b4ccd5e.svg";